import { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "./firebase";
import { DEFAULT_SEASON_RULES, Season } from "./types";

/**
 * Klubin kaudet uusin ensin. `reload` hakee listan uudestaan, esimerkiksi
 * kun kausi on juuri luotu tai päätetty.
 */
export function useClubSeasons(clubId: string): { seasons: Season[]; loaded: boolean; reload: () => void } {
  const [seasons, setSeasons] = useState<Season[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let alive = true;
    getDocs(query(collection(db, "clubs", clubId, "seasons"), orderBy("startsAt", "desc")))
      .then(snap => {
        if (!alive) return;
        setSeasons(snap.docs.map(d => {
          const data = d.data();
          return {
            id: d.id,
            ...data,
            // Vanhoissa dokumenteissa voi puuttua kenttiä; oletukset täyttävät ne.
            rules: { ...DEFAULT_SEASON_RULES, ...(data.rules ?? {}) },
          } as Season;
        }));
        setLoaded(true);
      })
      .catch(err => { console.error("seasons", err); if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, [clubId, tick]);

  return { seasons, loaded, reload: () => setTick(t => t + 1) };
}
